<template>
  <div class="nav-wrapper">
    <div class="experience-container">
      <div class="form-section">
        <div class="business-form">
          <BackButton @back="$emit('back')" />
          <h1 class="main-title">{{ $t("registeredAgent.title") }}</h1>
          <p class="subtitle">{{ $t("registeredAgent.subtitle") }}</p>

          <div class="registered-agent-card">
            <div class="card-header">
              <h2 class="card-title">{{ $t("registeredAgent.cardTitle") }}</h2>
              <span class="requirement-badge">{{
                $t("registeredAgent.requirementBadge")
              }}</span>
            </div>

            <div class="benefits-list">
              <div class="benefit-item">
                <div class="check-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 6L9 17L4 12"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>{{ $t("registeredAgent.benefits.address") }}</span>
              </div>
              <div class="benefit-item">
                <div class="check-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 6L9 17L4 12"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>{{ $t("registeredAgent.benefits.digital") }}</span>
              </div>
              <div class="benefit-item">
                <div class="check-icon">
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 6L9 17L4 12"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>{{ $t("registeredAgent.benefits.charge") }}</span>
              </div>
            </div>

            <div class="agent-options">
              <label class="agent-option">
                <input
                  type="radio"
                  v-model="registeredAgent"
                  value="tartoro"
                  class="radio-input"
                  name="agent"
                />
                <div class="option-content">
                  <span class="radio-custom"></span>
                  <span class="option-text">{{
                    $t("registeredAgent.options.tartoro")
                  }}</span>
                </div>
              </label>

              <label class="agent-option">
                <input
                  type="radio"
                  v-model="registeredAgent"
                  value="other"
                  class="radio-input"
                  name="agent"
                />
                <div class="option-content">
                  <span class="radio-custom"></span>
                  <span class="option-text">{{
                    $t("registeredAgent.options.other")
                  }}</span>
                </div>
              </label>
            </div>

            <p class="pricing-info">{{ $t("registeredAgent.pricingInfo") }}</p>
          </div>

          <button class="next-button" @click="handleNext">
            {{ $t("registeredAgent.next") }}
          </button>
        </div>
      </div>

      <div class="info-section">
        <div class="info-content">
          <h2 class="info-title">{{ $t("registeredAgent.infoTitle") }}</h2>
          <div class="video-container">
            <iframe
              src="https://www.youtube.com/embed/3lLCWiW0iBQ"
              title="Registered Agent Video"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              class="video-iframe"
            ></iframe>
          </div>

          <h3 class="info-subtitle">
            {{ $t("registeredAgent.infoSubtitle") }}
          </h3>
          <p class="info-text">{{ $t("registeredAgent.infoText") }}</p>

          <div class="illustration-container">
            <img
              src="@/assets/agent-illustration.png"
              alt="Agent Illustration"
              class="business-illustration"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackButton from "./BackButton.vue";

export default {
  name: "RegisteredAgent",
  components: {
    BackButton,
  },
  data() {
    return {
      registeredAgent: "tartoro",
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    formSectionPadding() {
      return this.windowWidth <= 800 ? "80px" : "180px";
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    handleNext() {
      this.$emit("next", {
        registeredAgent: this.registeredAgent,
      });
    },
  },
};
</script>

<style scoped>
@import "@/styles/CustomerBusiness.css";
</style>
